export default __webpack_public_path__ + "79eb207d4ef73e5e0a6e468dc440cd7f.svg";